import {Text, Rect} from 'react-konva';
import {Html} from 'react-konva-utils';
import {useRef, useState, useCallback} from 'react';
import DrawAction from "../enums/draw-action.js";

export default function EditableText({shape, drawAction, setShapes, onClick, onShapeMove, currentShape, onTextChange}) {
    const [isEditing, setIsEditing] = useState(false);
    const [textValue, setTextValue] = useState(shape.text || "");
    const textareaRef = useRef(null);
    const textRef = useRef(null);

    const handleDoubleClick = (e) => {
        e.cancelBubble = true;
        setIsEditing(true);
        setTextValue(shape.text || "");

        setTimeout(() => {
            const textarea = textareaRef.current;
            if (textarea) {
                textarea.focus();
                textarea.selectionStart = textarea.selectionEnd = textarea.value.length;

                const newHeight = textarea.scrollHeight;
                setShapes((prevShapes) => prevShapes.map((s) => s.id === shape.id ? {...s, height: newHeight} : s));
            }
        }, 0);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            textareaRef.current?.blur();
        } else if (e.key === 'Enter') {
            setIsEditing(false);
        }
    };

    const handleTransform = useCallback((e) => {
        const node = textRef.current;
        const scaleX = node.scaleX();
        const newWidth = node.width() * scaleX;

        setShapes(prevShapes => prevShapes.map(s => s.id === shape.id ? {...s, width: newWidth} : s));

        node.setAttrs({
            width: newWidth, scaleX: 1,
        });
    }, [setShapes, shape.id]);

    return (
        <>
            <Text
                ref={textRef}
                id={shape.id}
                x={shape.x}
                y={shape.y}
                width={shape.width}
                height={shape.height}
                text={shape.text}
                fontSize={shape.fontSize}
                fill={shape.color}
                onClick={onClick}
                onDblClick={handleDoubleClick}
                draggable={drawAction === null || currentShape?.current === shape.id}
                onDragEnd={(e) => {
                    const {x, y} = e.target.position();
                    onShapeMove(shape.id, x, y);
                }}
                visible={!isEditing}
                onTransform={handleTransform}
            />

            {
                shape.isCreating &&
                <Rect
                    x={shape.x}
                    y={shape.y}
                    width={shape.width}
                    height={shape.height}
                    stroke="gray"
                    dash={[4, 4]}
                    strokeWidth={2}
                    listening={false}
                />

            }

            {
                isEditing && (
                    <Html>
                        <textarea
                            ref={textareaRef}
                            value={textValue}
                            onChange={(e) => setTextValue(e.target.value)}
                            onBlur={() => {
                                onTextChange(shape.id, textValue)
                                setIsEditing(false);
                            }}
                            onKeyDown={handleKeyDown}
                            onInput={(e) => {
                                const textarea = e.target;
                                const newHeight = textarea.scrollHeight;

                                setShapes((prevShapes) => prevShapes.map((s) => s.id === shape.id ? {
                                  ...s,
                                  height: newHeight
                                } : s));
                            }}
                            style={{
                                position: 'absolute',
                                top: shape.y,
                                left: shape.x,
                                width: `${shape.width}px`,
                                height: `${shape.height}px`,
                                fontSize: `${shape.fontSize}px`,
                                fontFamily: 'sans-serif',
                                border: 'none',
                                padding: '0px',
                                margin: '0px',
                                background: 'none',
                                outline: 'none',
                                resize: 'none',
                                overflow: 'hidden',
                                color: shape.color,
                                lineHeight: '1.2',
                                textAlign: 'left',
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word',
                             }}
                        />
                    </Html>
                )
            }
        </>
    );
}
